import { ToggleTypes, useWidgetContext } from '../../../context/WidgetContext';
import { X } from 'react-bootstrap-icons';
import { isFullscreenWidgetMode } from '../../../types/agent-mode';

export const CloseButton = () => {
  const {
    toggle,
    isDocActive,
    isApiActive,
    isChatActive,
    isAIOpen,
    mode,
    config,
  } = useWidgetContext();

  const Close = () => {
    if (isDocActive) toggle(ToggleTypes.doc, true);
    if (isApiActive) toggle(ToggleTypes.api, true);
    if (isChatActive) toggle(ToggleTypes.chat, true);
    if (isAIOpen) toggle(ToggleTypes.ai, true);
    if (isFullscreenWidgetMode(mode) || config.fullscreenChat) toggle(ToggleTypes.widget, false)
  };

  return (
    <button
      className="osirus-agent-close-btn"
      onPointerDownCapture={(e) => e.stopPropagation()}
      onClick={(e) => {
        e.stopPropagation()
        Close()
      }}
    >
      <X />
    </button>
  );
};
